import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  margin: auto;
  box-sizing: border-box;
  flex-direction: column;
  padding: 1em 2em;
  // background-color: ${({ theme }) => theme.palette.primary.light};
  &.mobile {
    width: 100%;
    padding: 2em 2em;
  }
`
export const FoldWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 0.1fr;
  align-items: center;
  justify-items: start;
  border-bottom: 1px solid #d8d8d8;
  padding: 1em 0;

  :last-of-type {
    margin-bottom: 55px;
    border-bottom: none;
  }
`

export const Paragraph = styled.div`
  text-align: justify;
  font-family: ${props => props.theme.typography.body.fontFamily};
  font-weight: ${props => props.theme.typography.body.fontWeight};
  font-size: 0.9rem;
  margin: 0 2em 15px 0;
  h1,
  h2 {
    text-align: center;
    margin: 0 0 15px 0;
  }
  p {
    margin: 0;
  }
  a {
    color: black;
  }
`
export const Title = styled.h2`
  // margin-bottom: 2em;
  ${({ theme }) => theme.typography.h2};
  font-size: 2.25em;
`
export const Question = styled(Paragraph)`
  font-weight: bold;
`
